export default "__VITE_ASSET__BJ6TfW3d__"